import dashboard from './dashboard'
export default [...dashboard]
// , ...appAndPages, ...uiElements, ...forms, ...charts, ...others
